export default __webpack_public_path__ + "assets/images/e5fdaa57f61d6de9905a50967dcdbe70.png";